module.exports = __webpack_public_path__ + "static/result-with-hand-0d9fada1723c40e860f1ff0603aac065.png";